/**
 * Display helpers for the orders surface (AUT-123). Mirrors the users
 * surface (`pages/users/_lib/displayName.ts`) — kept page-local so the
 * orders page never imports across the users page boundary.
 *
 * The server sends customer / inspector names already redacted-or-full
 * per `piiRevealed`. These helpers only derive avatar initials + a short
 * id from values the SPA already holds — they never reconstruct PII.
 */

/** Two-letter avatar initials from a name; '—' fallback (null / empty). */
export const initials = (name: string | null): string => {
  if (!name) return '—';
  const parts = name.trim().split(/\s+/).filter(Boolean);
  const first = parts[0];
  if (!first) return '—';
  const second = parts[1];
  if (!second) return first.slice(0, 2).toUpperCase();
  return ((first[0] ?? '') + (second[0] ?? '')).toUpperCase();
};

/** Truncate a uuid to the mockup's `ord_a31f…9c2` shape. */
export const shortId = (id: string): string => {
  if (id.length <= 11) return id;
  return `${id.slice(0, 8)}…${id.slice(-3)}`;
};
